import { Badge } from './Badge';
import type { RsvpStatus } from '../../types';

const variants: Record<RsvpStatus, { variant: 'success' | 'error' | 'warning' | 'default'; label: string }> = {
  pending: { variant: 'default', label: 'Awaiting' },
  yes: { variant: 'success', label: 'Attending' },
  no: { variant: 'error', label: 'Not Attending' },
  maybe: { variant: 'warning', label: 'Maybe' },
};

export function RsvpBadge({ status }: { status: RsvpStatus }) {
  const { variant, label } = variants[status];
  return <Badge variant={variant}>{label}</Badge>;
}
